export const SEND_EMAIL_MUTATION = "sendEmail";
export const GET_DRAWING_MUTATION = "getDrawing";
export const GET_STREAM_LINK_MUTATION = "getStreamLink";